import React from "react";

var InformationIcon = function InformationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.489 3.511c-4.682-4.682-12.297-4.682-16.979 0-4.681 4.681-4.681 12.298 0 16.978C5.852 22.831 8.925 24 12 24s6.148-1.169 8.489-3.51c4.681-4.681 4.681-12.298 0-16.979zM13 18.006a1 1 0 0 1-2 0l.001-.006-.001-.005a1 1 0 0 1 2 0l-.001.006.001.005zm4-8.011c0 .938-.448 1.835-1.199 2.399l-3.201 2.4a.998.998 0 0 1-1.4-.2 1 1 0 0 1 .2-1.4l3.2-2.4c.25-.188.399-.487.399-.8v-1c0-.551-.448-1-1-1h-3c-.552 0-1 .449-1 1a1 1 0 1 1-2 0c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v1.001z"
  }));
};

InformationIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
InformationIcon.defaultProps.solid = true;
export default InformationIcon;